import React from 'react';
import './Star.scss';

export default function Star(props) {
    return <i {...props} className="full-star" />;
}
